var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6762 22.0182H23.2838V18.6259C23.5923 18.7184 23.9315 18.7492 24.2708 18.7492C26.4911 18.7492 28.3105 16.9606 28.3105 14.7095C28.3105 13.1676 27.4471 11.8107 26.1519 11.1323C25.7202 9.34385 24.1165 7.98721 22.1739 7.98721C21.3104 7.98721 20.4777 8.2647 19.8302 8.72737C19.9227 9.22083 19.9844 9.71429 19.9844 10.2075C19.9844 12.7978 18.5968 15.0799 16.5614 16.3442C17.1781 17.7319 18.5968 18.7188 20.2312 18.7188C20.6012 18.7188 20.9404 18.6571 21.2797 18.5646V21.9876L11.2572 21.9874C11.2572 21.9256 11.2879 21.8331 11.2879 21.7714L11.2882 16.1897C11.7816 16.313 12.2751 16.3747 12.7993 16.3747C16.1916 16.3747 18.9361 13.6302 18.9361 10.238C18.9361 7.86346 17.6102 5.82834 15.6363 4.81064C15.0196 2.06607 12.5833 0 9.65366 0C6.69307 0 4.19521 2.12786 3.64018 4.93415C1.75882 5.98258 0.525391 7.9562 0.525391 10.2382C0.525391 13.6305 3.27001 16.375 6.66223 16.375C7.21721 16.375 7.74168 16.3132 8.26588 16.159V21.8023C8.26588 21.864 8.26588 21.9565 8.29664 22.0183H2.1598C1.45057 22.0183 0.86459 22.6042 0.86459 23.3135C0.86459 24.0227 1.45057 24.6086 2.1598 24.6086H26.6763C27.3856 24.6086 27.9715 24.0227 27.9715 23.3135C27.9715 22.604 27.3858 22.0181 26.6763 22.0181L26.6762 22.0182Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.0ec49a8da833f29a314bd04c143b5fb2.svg";
export { ForwardRef as ReactComponent };